/**
 * @author gll
 * 模块说明：采购策略—供应商寻源配置
 */
import { Service } from '@/tools'

export class RequireConfigSourceService<T extends TProcure.RequireConfigSource> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.RequireConfigSource}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：分页查询寻源配置-列表信息
   * /api/procure/require/config/source/v1/page
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：寻源配置-修改
   * /api/procure/require/config/source/v1/update
   */
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiUpdate', data, '操作成功')
  }

  /**
   * 模块说明：分页查询寻源配置-明细信息
   * /api/procure/require/config/source/v1/detail
   */
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiDetail', data)
  }

  /**
   * 模块说明：  寻源配置-新增
   * /api/procure/require/config/source/v1/add
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAdd', data, '操作成功')
  }

  /**
   * 模块说明：  查询寻源配置-规则及优先级信息
   * /api/procure/require/config/source/v1/selectRuleItemByParentId
   */
  selectRuleItemByParentId = <K extends T['ApiSelectRuleItemByParentId']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiSelectRuleItemByParentId', data)
  }

  /**
   * 模块说明：  查询寻源配置-基础信息
   * /api/procure/require/config/source/v1/info
   */
  info = <K extends T['ApiInfo']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiInfo', data)
  }

  /**
   * 模块说明：  寻源配置-启用-禁用
   * /api/procure/require/config/source/v1/enable
   */
  enable = <K extends T['ApiEnable']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiEnable', data, '操作成功')
  }
  /**
   * 模块说明：  查询寻源配置-基础信息（人工备货）
   * /api/procure/require/config/source/v1/infoByCondition
   */
  infoByCondition = <K extends T['ApiInfoByCondition']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiInfoByCondition', data)
  }
}
